import { render, staticRenderFns } from "./NavigationGroup.vue?vue&type=template&id=d61d0594&"
import script from "./NavigationGroup.vue?vue&type=script&lang=js&"
export * from "./NavigationGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports